// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"524ca08f","335":"ca222909","338":"0d4ccf2f","365":"7d1f5891","475":"5aa92caf","545":"7de345dc","899":"e2e3febf","996":"0d4ccf2f"}[chunkId] + ".chunk.css";
};